import { render, staticRenderFns } from "./ReviewingStatus.vue?vue&type=template&id=dafd7bc8&scoped=true&"
import script from "./ReviewingStatus.vue?vue&type=script&lang=js&"
export * from "./ReviewingStatus.vue?vue&type=script&lang=js&"
import style0 from "./ReviewingStatus.vue?vue&type=style&index=0&id=dafd7bc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafd7bc8",
  null
  
)

export default component.exports